import PropTypes from 'prop-types';
import React, {
	Component,
} from 'react';
import {
	FormattedMessage,
	FormattedNumber,
	defineMessages,
} from 'react-intl';

import AlertPagesButton from '../AlertPagesButton';
import ExpressiveValue, {
	ExpressiveValueLabelFlow,
	ExpressiveValueSize,
	ExpressiveValueStatus,
} from '~/components/patterns/values/ExpressiveValue';
import IncidentBoxContent from '~/components/patterns/incidents/IncidentBoxContent';
import RemovedFromAlertMetric from './RemovedFromAlertMetric';
import SeparatedBlocks from '~/components/patterns/structures/SeparatedBlocks';

import {
	countPagesSplit,
} from '~/model/alerts';



const messages = defineMessages({
	affected: {
		id: 'ui.alerts.overview.incident.details.affected',
	},
	reverted: {
		id: 'ui.alerts.overview.incident.details.reverted',
	},
});



class ContentChangeDetails extends Component {

	render() {
		const {
			incident,
			websiteId,
		} = this.props;

		const isIncidentActive = incident.get('phase') === 'active';

		const isModern = incident.hasIn(['state', 'pages', 'split']);

		const numberOfAffected = isModern
			? countPagesSplit(incident, 'changed')
			: incident.getIn(['state', 'affected_pages']);

		const numberOfReverted = isModern
			? countPagesSplit(incident, 'restored')
			: null;

		const numberOfRemovedFromAlert = isModern
			? (
				countPagesSplit(incident, 'not_applicable')
				+ countPagesSplit(incident, 'not_page')
				+ countPagesSplit(incident, 'over_quota')
			)
			: 0;

		const numberOfAlertPages = (
			numberOfAffected
			+ (numberOfReverted || 0)
			+ numberOfRemovedFromAlert
		);

		return (
			<IncidentBoxContent
				button={numberOfAlertPages > 0 && (
					<AlertPagesButton
						focusOnPrimary={isIncidentActive && numberOfAffected > 0}
						incident={incident}
						websiteId={websiteId}
					/>
				)}
			>
				<SeparatedBlocks divider={false}>
					<ExpressiveValue
						label={(
							<FormattedMessage
								{...messages.affected}
								values={{
									count__pages: numberOfAffected,
								}}
							/>
						)}
						labelFlow={ExpressiveValueLabelFlow.Column}
						size={ExpressiveValueSize.Large}
						status={isIncidentActive ? ExpressiveValueStatus.Warning : ExpressiveValueStatus.Neutral}
						value={(
							<FormattedNumber value={numberOfAffected} />
						)}
					/>

					{numberOfReverted !== null && (
						<ExpressiveValue
							label={(
								<FormattedMessage
									{...messages.reverted}
									values={{
										count__pages: numberOfReverted,
									}}
								/>
							)}
							labelFlow={ExpressiveValueLabelFlow.Column}
							size={ExpressiveValueSize.Large}
							status={ExpressiveValueStatus.Neutral}
							value={(
								<FormattedNumber value={numberOfReverted} />
							)}
						/>
					)}
				</SeparatedBlocks>

				{numberOfRemovedFromAlert > 0 && (
					<RemovedFromAlertMetric
						numberOfRemovedFromAlert={numberOfRemovedFromAlert}
					/>
				)}
			</IncidentBoxContent>
		);
	}

}

ContentChangeDetails.propTypes = {
	incident: PropTypes.object.isRequired,
	websiteId: PropTypes.string,
};



export default ContentChangeDetails;
